module.exports = __webpack_public_path__ + "img/inactiveallocate.75edfbd5.svg";